import { render, staticRenderFns } from "./modal-container.vue?vue&type=template&id=304aefc1&scoped=true&"
import script from "./modal-container.ts?vue&type=script&lang=ts&"
export * from "./modal-container.ts?vue&type=script&lang=ts&"
import style0 from "./modal-container.scss?vue&type=style&index=0&id=304aefc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304aefc1",
  null
  
)

component.options.__file = "modal-container.vue"
export default component.exports